// app/frontend/components/ui/Forms/L2KSelect.tsx
import { Select, SelectProps } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import "./forms.css";

export function L2KSelect(props: SelectProps) {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Select
      radius="md"
      classNames={{
        option: "l2k-select-option",
      }}
      styles={{
        root: {
          minWidth: isMobile ? "100%" : undefined,
        },
        label: {
          fontSize: "14px",
          fontFamily: "'Public Sans', sans-serif",
          fontWeight: 500,
          color: "#F0F0F0",
          marginBottom: 6,
        },
        input: {
          fontSize: "14px",
          fontFamily: "'Public Sans', sans-serif",
          backgroundColor: "rgba(255, 255, 255, 0.03)",
          borderColor: "rgba(255, 152, 0, 0.2)",
          color: "#F0F0F0",
          "--input-placeholder-color": "#B8B8B8",
          "&:focus": {
            borderColor: "#FF9800",
            boxShadow: "0 0 0 2px rgba(255, 152, 0, 0.15)",
          },
          "&:hover:not(:focus)": {
            borderColor: "rgba(255, 152, 0, 0.4)",
          },
        },
        dropdown: {
          backgroundColor: "rgba(23, 23, 23, 0.95)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 152, 0, 0.2)",
        },
        option: {
          fontFamily: "'Public Sans', sans-serif",
          color: "#D0D0D0",
          "&[data-selected]": {
            backgroundColor: "rgba(255, 152, 0, 0.2)",
            color: "#FF9800",
          },
        },
        error: {
          color: "#ff6b6b",
          fontFamily: "'Public Sans', sans-serif",
        },
        description: {
          color: "#B8B8B8",
          fontFamily: "'Public Sans', sans-serif",
        },
      }}
      {...props}
    />
  );
}

export default L2KSelect;
